"use client";

import { c as _c } from "react/compiler-runtime";
import { ListboxButton } from "@headlessui/react";
import { Down } from "@icon-park/svg";
import clsx from "clsx";
import { forwardRef } from "react";
import Icon from "../Icon";
import { SelectButtonProps } from "./types";
const SelectButton = forwardRef<any, SelectButtonProps>(function SelectButton(t0, ref) {
  const $ = _c(15);
  const {
    disabled,
    size,
    className,
    children
  } = t0;
  const t1 = disabled ? -1 : 0;
  const t2 = !disabled;
  const t3 = size === "sm";
  const t4 = size === "md";
  let t5;
  if ($[0] !== className || $[1] !== disabled || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = clsx("w-full border transition-colors ease-out flex items-center justify-between bg-neutral-0 border-neutral-50 text-neutral-575", {
      "cursor-pointer hover:border-neutral-100 focus-within:border-neutral-100 focus:outline-none": t2,
      "bg-neutral-12 border-neutral-25 cursor-not-allowed": disabled,
      "text-app-body-2 py-[7px] px-3xs rounded-xs": t3,
      "text-body-2 py-[11px] px-s rounded-s": t4
    }, className);
    $[0] = className;
    $[1] = disabled;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== disabled || $[8] !== size) {
    t6 = t7 => {
      const {
        open
      } = t7;
      return <>{children}<span className={clsx("ml-xs  flex relative", {
          "text-primary-800": !disabled,
          "text-neutral-150": disabled
        })} aria-hidden="true"><Icon icon={Down} size={size === "sm" ? 20 : 24} className={clsx({
            "rotate-180": open
          })} /><div className="absolute inset-none" /></span></>;
    };
    $[6] = children;
    $[7] = disabled;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== ref || $[11] !== t1 || $[12] !== t5 || $[13] !== t6) {
    t7 = <ListboxButton ref={ref} tabIndex={t1} className={t5}>{t6}</ListboxButton>;
    $[10] = ref;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
});
export default SelectButton;